import ConfirmModal from '@/components/ConfirmModal';
import { TransText } from '@/i18n/trans/text';
import { Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

interface BookingExpiredDialogProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  onCancel: () => void;
}

const BookingExpiredDialog: FC<BookingExpiredDialogProps> = ({
  open,
  setOpen,
  onCancel,
}) => {
  return (
    <ConfirmModal
      open={open}
      setOpen={setOpen}
      onCancel={onCancel}
      title={
        <Typography variant="subtitle">
          <TransText i18nKey="bookingSessionExpired" />
        </Typography>
      }
      description={
        <Typography variant="paragraph">
          <TransText i18nKey="bookingSessionExpiryDescription" />
        </Typography>
      }
      cancelLabel="backToJourneySearch"
      showClose={false}
      interactOutside={false}
    />
  );
};

export default BookingExpiredDialog;
